import {css} from "@emotion/css";
import {RouteHelper} from "../../route/RouteHelper";
import {useLocation, useNavigate} from "react-router-dom";
import Box from "@mui/material/Box";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import {useState} from "react";
import TabPanel from "@mui/lab/TabPanel";
import WriterPersonInfo from "../../component/writers/WriterPersonInfo";
import WriterAccessState from "../../component/writers/WriterAccessState";
import {
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoButtonSecondary,
    RaikoFlexFirstChildGrowOne,
    RaikoGridOneColumn
} from "@moeindal/base-raiko-panel-components";

export default function MagazineWriterDetail() {


    const navigate = useNavigate()
    const {state} = useLocation()

    const [pageTitle, setPageTitle] = useState(state && state.title ? state.title : RouteHelper.MagazineWriterDetail.name);

    const [tabSelectedValue, setTabSelectedValue] = useState(magazineWritersTabTypes.detail.id)

    function handleChangeTab(event, newValue) {
        setTabSelectedValue(newValue)
    }

    return (
        <RaikoBaseContainer>
            <RaikoGridOneColumn>
                <RaikoFlexFirstChildGrowOne>
                    <RaikoBreadcrumb
                        className={css`flex-grow: 1`}
                        breadCrumbItems={[
                            raikoBreadCrumbItemGenerator(
                                RouteHelper.MagazineWriters.name,
                                RouteHelper.MagazineWriters.globalUrl
                            ),
                            raikoBreadCrumbItemGenerator(
                                pageTitle,
                                ""
                            ),
                        ]}/>

                    <RaikoButtonSecondary
                        label={"بازگشت"}
                        onClick={_ => {
                            navigate(RouteHelper.MagazineWriters.globalUrl)
                        }}/>
                </RaikoFlexFirstChildGrowOne>

                <TabContext value={tabSelectedValue}>
                    <Box sx={{borderBottom: 1, borderColor: 'divider'}} className={css`
                      border-color: var(--header-border-bottom-color) !important;
                    `}>
                        <TabList onChange={handleChangeTab} id="default-tab-container" variant="scrollable">
                            <Tab icon={<div id="tabIcon"/>} iconPosition="start"
                                 label={magazineWritersTabTypes.detail.title}
                                 value={magazineWritersTabTypes.detail.id}
                            />
                            <Tab icon={<div id="tabIcon"/>} iconPosition="start"
                                 label={magazineWritersTabTypes.access.title}
                                 value={magazineWritersTabTypes.access.id}
                            />
                        </TabList>
                    </Box>

                    <TabPanel value={magazineWritersTabTypes.detail.id}>
                        <WriterPersonInfo/>
                    </TabPanel>
                    <TabPanel value={magazineWritersTabTypes.access.id}>
                        <WriterAccessState/>
                    </TabPanel>
                </TabContext>

            </RaikoGridOneColumn>
        </RaikoBaseContainer>

    )
}

const magazineWritersTabTypes = {
    detail: {
        id: "detail",
        title: "اطلاعات پایه"
    }, access: {
        id: "access",
        title: "دسترسی"
    },

}
